export default [
    {
        role   : 'all',
        slug   : 'uncategorized',
        section: null,
        childs : [
            {
                path  : '/',
                label : 'Dashboard',
                icon  : 'dashboard',
            },
        ]
    },
    {
        role   : 'all',
        slug   : 'contact_manager',
        section: 'Contact Manager',
        childs : [
            {
                path   : '/enterprises',
                label  : 'Enterprises',
                icon   : 'enterprise',
            },
            {
                path   : '/audiences',
                label  : 'Audiences',
                icon   : 'audience',
            }
        ]
    },
    {
        role   : 'all',
        slug   : 'campaign_manager',
        section: 'Campaign Manager',
        childs : [
            {
                path   : '/sms',
                label   : 'SMS',
                icon   : 'sms',
            },
            {
                path   : 'https://my.linkmobility.solutions/templates',
                label   : 'RCS',
                icon   : 'rcs',
            },
            {
                path   : '/emails',
                label   : 'Email',
                icon   : 'email',
            },
            {
                path   : '/landings',
                label   : 'Landing',
                icon   : 'landing',
            },
            {
                path   : '/journeys',
                label   : 'Journeys',
                icon   : 'journey',
            },
            {
                path : 'https://app.trengo.com/auth/login',
                label: 'Whatsapp',
                icon : 'whatsapp',
            },
        ]
    },
    {
        role   : 'admin',
        slug   : 'account_manager',
        section: 'Account Manager',
        childs : [
            {
                path   : '/roles',
                label   : 'Roles',
                icon   : 'role',
            },
            {
                path   : '/users',
                label   : 'Users',
                icon   : 'user',
            },
        ]
    },
    {
        slug   : 'app_manager',
        role   : 'super-admin',
        section: 'System Manager',
        childs : [
            {
                path   : '/plans',
                label   : 'Plans',
                icon   : 'plan',
            },
            {
                path   : '/accounts',
                label   : 'Accounts',
                icon   : 'account',
            }
        ]
    }
]